import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import Modal from 'modals/dialog'
import { Steps } from './s'
import OneWho from './1-who'
import TwoWhat from './2-what'
import ThreeFormat from './3-format'

const ExportUsers = ({ formData: outsideFormData = {}, salt }) => {
    const { formatMessage } = useIntl()

    const [step, setStep] = useState(1)
    const [formData, setFormData] = useState(outsideFormData)

    const previous = () => setStep(step => step - 1)
    const next = () => setStep(step => step + 1)

    const props = {
        outsideFormData,
        formData,
        setFormData,
        previous,
        next,
        salt
    }

    return (
        <>
            <Modal.Header
                heading={formatMessage({
                    id: 'people_action_export',
                    defaultMessage: 'Export users'
                })}
                childrenClassName="fullwidth">
                <Steps
                    steps={[
                        {
                            text: formatMessage({
                                id: 'question_who',
                                defaultMessage: 'Who?'
                            })
                        },
                        {
                            text: formatMessage({
                                id: 'question_what',
                                defaultMessage: 'What?'
                            })
                        },
                        {
                            text: formatMessage({
                                id: 'noun_format',
                                defaultMessage: 'Format'
                            })
                        }
                    ]}
                    at={step - 1}
                    className="compact" />
            </Modal.Header>
            {(step === 1) && <OneWho {...props} />}
            {(step === 2) && <TwoWhat {...props} />}
            {(step === 3) && <ThreeFormat {...props} />}
        </>
    )
}

export default ExportUsers